import { useEffect, useState } from 'react';

interface UseRecaptchaEnterpriseReturn {
  isRecaptchaReady: boolean;
}

export const useRecaptchaEnterprise = (siteKey: string): UseRecaptchaEnterpriseReturn => {
  const [isRecaptchaReady, setIsRecaptchaReady] = useState(false);

  useEffect(() => {
    if (!siteKey) {
      return;
    }

    // Check if reCAPTCHA is already available
    const checkRecaptcha = () => {
      if (window.grecaptcha?.enterprise) {
        window.grecaptcha.enterprise.ready(() => {
          setIsRecaptchaReady(true);
        });
        return true;
      }
      return false;
    };

    // First check if already loaded
    if (checkRecaptcha()) {
      return;
    }

    // If not loaded, load it dynamically
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${siteKey}`;
    script.async = true;
    script.defer = true;

    script.onload = () => {
      checkRecaptcha();
    };

    script.onerror = () => {
      // reCAPTCHA Enterprise script failed to load
    };

    document.body.appendChild(script);

    // Set up timeout to detect if it never loads
    const timeout = setTimeout(() => {
      // reCAPTCHA Enterprise failed to load after timeout
    }, 10000);

    return () => {
      clearTimeout(timeout);
      // Clean up script if component unmounts
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, [siteKey, isRecaptchaReady]);

  return {
    isRecaptchaReady
  };
};
